import React from 'react'
import iconCheck from '../../../shared/assets/images/icon-check.svg'
import Button from '../../../shared/components/atoms/Button/Button'
import LayoutModal from '../../../shared/components/organisms/layoutModal/layout-modal'
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode'
import * as constants from '../../../shared/state/constants/appConstants'
import {
	localStorage,
	sessionStorage,
} from '../../../shared/state/utils/storage'
import AlertMessagge from '../../molecules/alertMessagge/alertMessagge'
import ChangePassword from '../../molecules/changePassword/changePassword'
import PasswordChangeModal from '../../molecules/passwordChangeModal/passwordChangeModal'
import './changePassContainer.scss'
import ModalOTP from '../../../shared/components/molecules/modalOTP/modalOTP'
import SessionService from '../../../shared/services/session'
import useBrowserMode from '../../../shared/hooks/useBrowserMode'
import { convertText } from '../../../shared/utils/convertFirstCharacterToUppercase'

const ChangePassContainer = ({
	type,
	tempPass,
	closeModal,
	actualStorage,
	formValues,
}) => {
	const [isPasswordChanged, setPasswordChanged] = React.useState(false)
	const [currentPayload, setCurrentPayload] = React.useState()
	const [isShowingOTPModal, setOTPModalVisibility] = React.useState(false)
	const [currentSlider, setCurrentSlider] = React.useState()
	const { isBrowser } = useBrowserMode()
	const data = isBrowser && SessionService.getUserData()
	const { homeLink } = useHomeLinkMode()

	const NavigateToMyContent = actualStorage => {
		const _storage = actualStorage === 0 ? localStorage : sessionStorage
		const userData = _storage.getItem('userData')
		if (
			userData.roles[0].nombreRol === constants.ROL_USUARIO.nombreRol ||
			userData.roles[0].nombreRol === constants.ROL_COMPRADOR.nombreRol ||
			userData.roles[0].nombreRol === constants.ROL_INTERESADO.nombreRol
		) {
			switch (userData.gender) {
				case 'Masculino':
					window.location.href = homeLink + 'hombres'
					break
				case 'Femenino':
					window.location.href = homeLink + 'mujeres'
					break
				default:
					break
			}
		} else {
			switch (userData.roles[0].nombreRol) {
				case constants.ROL_CUIDADOR_FAMILIAR.nombreRol:
					window.location.href = homeLink + 'cuidadores/cuidas-a-alguien'
					break
				case constants.ROL_CUIDADOR_PROFESIONAL.nombreRol:
					window.location.href = homeLink + 'cuidadores/eres-un-profesional'
					break
				case constants.ROL_INSTITUCION.nombreRol:
				case constants.ROL_ADMINISTRADOR_INSTITUCION.nombreRol:
				case constants.ROL_COLABORADOR_INSTITUCION.nombreRol:
					window.location.href = homeLink + 'cuidadores/institucion'
					break
				default:
					break
			}
		}
	}

	return (
		<>
			{type === 0 ? (
				<LayoutModal>
					<PasswordChangeModal
						closeModal={closeModal}
						actualStorage={actualStorage}
						formValues={formValues}
						type={type}
						setCurrentPayload={setCurrentPayload}
						setOTPModalVisibility={setOTPModalVisibility}
						setCurrentSlider={setCurrentSlider}
					/>
				</LayoutModal>
			) : (
				<section className='f-section-passchange'>
					{!isPasswordChanged ? (
						<ChangePassword
							type={type}
							setCurrentPayload={setCurrentPayload}
							setOTPModalVisibility={setOTPModalVisibility}
							tempPass={tempPass}
							setPasswordChanged={setPasswordChanged}
							actualStorage={actualStorage}
						/>
					) : (
						<AlertMessagge
							icon={<img src={iconCheck} alt='check-correct' />}
							messagge='TU CONTRASEÑA HA SIDO CAMBIADA CON ÉXITO'
							description=''
							type='success'
							button={
								<Button
									type='button'
									onClickAction={() => {
										NavigateToMyContent(actualStorage)
									}}
									classname='f-button f-button--primary'
									text={convertText(`BIENVENID${
										data.gender.toLowerCase() === 'femenino' ? 'A' : 'O'
									}`)}
								/>
							}
						/>
					)}
				</section>
			)}
			{isShowingOTPModal && (
				<ModalOTP
					payload={currentPayload}
					classname='f-pass-otp f-no-min-h'
					type='userPass'
					actualStorage={actualStorage}
					currentSlider={currentSlider}
					setPasswordChanged={setPasswordChanged}
					passContentType={type}
					onClose={() => {
						setOTPModalVisibility(false)
					}}
				/>
			)}
		</>
	)
}

export default ChangePassContainer
